export enum TipoCanalesCodigo {
  WEB = 'WEB',
  APP = 'APP',
  OFV = 'OFV',
  TODOS_LOS_CANALES = '',
}
